<template>
    <page-wrap class="wxsm">
        <el-card class="box-card" shadow="never" style="width: 100%;">
            <h2 class="xpqd">微信绑定</h2>
            <p>用微信扫描下方二维码，进行绑定操作，即可第一时间收到微信服务通知，询盘信息实时送达！</p>
            <img :src="wechat" style="height: 200px;width: 200px;margin:20px 100px ">
        </el-card>
    </page-wrap>

</template>
<script>
    export default {
        data() {
            return {
                wechat: ''
            }
        }, mounted() {
            let that = this
            this.$ajax.get('business/person/wechat').then(function (res) {
                if (res.data.error === 0) {
                    that.wechat = res.data.data
                }
            })
        },
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// src/views/business/Wechat.vue